// @ts-strict-ignore
import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { getCurrentEmployeePermissions } from '../../store';
import { FcPermissionCode, Permission } from '@fc-core';
import { NgIfContext } from '@angular/common';

@Directive({
  selector: '[fcHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input() fcHasPermission: FcPermissionCode;
  @Input() fcHasPermissionElse: TemplateRef<NgIfContext>;

  private permissionSubscription: Subscription;
  private permissions: Permission[];
  private emptyStateRendered = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private store: Store,
  ) {}

  ngOnInit() {
    this.permissionSubscription = this.store
      .select(getCurrentEmployeePermissions)
      .subscribe((permissions: Permission[]) => {
        if (permissions) {
          this.permissions = permissions;
          this.setPermission();
        }
      });
  }

  ngOnDestroy() {
    if (this.permissionSubscription) {
      this.permissionSubscription.unsubscribe();
    }
  }

  private setPermission(): void {
    const hasPermission = this.permissions.some(
      (permission) => permission.codename === this.fcHasPermission,
    );

    if (!hasPermission) {
      if (this.emptyStateRendered) return;
      this.viewContainerRef.clear();
      if (this.fcHasPermissionElse) {
        this.viewContainerRef.createEmbeddedView(this.fcHasPermissionElse);
        this.emptyStateRendered = true;
      }
    } else {
      this.emptyStateRendered = false;
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
